import service from '@/utils/server'

const modName = '/recycling/order/assign/'
const downloadFileModeName = '/common/web/download/';

// 查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  })
}
// 初始化页面对象
export const initPage = data => {
  return service({
    url: modName + 'initPage',
    method: 'post',
    data
  })
}


// 导出excel
export const exportData = data => {
  const config = {
    timeout: 500000, // 请求超时时间
    responseType: 'blob'
  }
  return service({
    ...config,
    url: modName + 'export',
    method: 'post',
    data
  })
}

// 根据id获取详情
export const initOrderDetail = data => {
  return service({
    url: modName + 'initUpdate/' + data,
    method: 'post',
    data
  })
}

// 添加产品搜索
export const schOrderAndCustomerSkuList = data => {
  return service({
    url: modName + 'schOrderAndCustomerSkuList',
    method: 'post',
    data
  })
}

// 提交修改
export const update = data => {
  return service({
    url: modName + 'update',
    method: 'post',
    data
  })
}

//文件上传路径
export const uploadUrl = () => {
  return `${process.env.BASE_URL}${modName}uploadOrderFile`;
};
//初始化订单详情信息
export const orderBasicDetailsInfo = data => {
  return service({
    url: modName + 'orderBasicDetailsInfo',
    method: 'post',
    data
  })
};

// 根据订单id获取添加产品列表
export const customerSkuList = data => {
  return service({
    url: modName + 'schOrderAndCustomerSkuList',
    method: 'post',
    data
  })
}
// 根据客户编码获取租赁方列表(下拉框)
export const customerOptions = data => {
  return service({
    url: modName + 'userNoAndCustomerList',
    method: 'post',
    data
  })
}
// 根据客户编码获取收货方列表(下拉框)
export const consigneesOptions = data => {
  return service({
    url: '/common/web/select/findConsigneesByCustomerCode/' + data,
    method: 'post'
  })
}
// 根据客户编码获取收货地址列表(下拉框)
export const addressOptions = data => {
  return service({
    url: '/common/web/select/findAddrsByConsigneeCode/' + data,
    method: 'post',
    data
  })
}
// 根据客户编码获取订单类型列表(下拉框)
export const orderTypesOptions = data => {
  return service({
    url: '/common/web/select/findOrderTypesByCustomerCode/' + data,
    method: 'post'
  })
}

//文件下载
export const fileDownload = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    responseType: "blob"
  };
  return service({
    ...config,
    url: downloadFileModeName + 'file/'+data,
    method: 'post',
    data
  });
};

// 取消订单
export const cancelSchOrder = data => {
  return service({
    url: modName + 'cancelSchOrder',
    method: 'post',
    data
  })
}

// 查询gps轨迹信息
export const orderTracking = data => {
  return service({
    url: modName + 'orderTracking',
    method: 'post',
    data
  })
}

//分配承运商
export const distributionList = data => {
  return service({
    url: modName + 'distributionList',
    method: 'post',
    data
  })
}
//预览pdf
export const printPdf = data => {
  return service({
    url: modName + 'printPdfSearch/' + data,
    method: 'post'
  });
};
//发货单打印记录打印操作
export const doPrint = data => {
  return service({
    url: modName + 'doPrint',
    method: 'post',
    data
  });
};
//明细-预览pdf
export const printSkuPdf = data => {
  return service({
    url: modName + 'printPdfSkuSearch/' + data,
    method: 'post'
  });
};



// WEBPACK FOOTER //
// ./src/page/recovery/allocation/api/index.js